import { constructFrom as n } from "./constructFrom.js";
function l(e, t) {
  const s = t instanceof Date ? n(t, 0) : new t(0);
  return s.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), s.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), s;
}
export {
  l as default,
  l as transpose
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/transpose.js
// module id = 1450
// module chunks = 67